const zh = {
  login: '登录',
  account: '账号',
  connect: '连接钱包',
  mint: '铸造',
  repeatTime: '铭刻次数',
  hexString: '16进制数据',
  textString: '文本数据',
  inscribeContent: '铭文内容',
  network: '网络选择',
  easyInsc: '铭文助手',
  switchNetwork: '切换网络',
  minting: '铭刻中',
  currentAddress: '当前地址',
  currentChain: '当前网络',
  repeatTips: "每次铭刻都需要进行签名",
  downloadTP: '请下载TokenPocket钱包使用: <a href="https://tokenpocket.pro/?from=insc" target="_blank">TokenPocket Wallet </a>'
};

export default zh;